import serviceConfig from './service';

let ENV: 'development' | 'development_2' | 'qa' | 'qa2' | 'production';
if (window.location.host.includes('localhost')) {
	ENV = process.env.NODE_ENV === 'development_2' ? 'development_2' : 'development';
} else if (window.location.host.includes('qa')) {
	ENV = process.env.NODE_ENV === 'development_2' ? 'qa2' : 'qa';
} else {
	ENV = 'production';
}

const service = serviceConfig[ENV];

export {
	service
}